import { render, staticRenderFns } from "./recycleComponent.vue?vue&type=template&id=5667d1a3&scoped=true&"
import script from "./recycleComponent.vue?vue&type=script&lang=js&"
export * from "./recycleComponent.vue?vue&type=script&lang=js&"
import style0 from "./recycleComponent.vue?vue&type=style&index=0&id=5667d1a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5667d1a3",
  null
  
)

export default component.exports